import { EBuyPackageSource } from '../../../../../reducers/v2/recommendedPackages/types';
import { EPackageType } from '../../../../../../PayPackageMicrofrontend/types/api';

export const mapWidgetSource = (type: EPackageType): EBuyPackageSource => {
  switch (type) {
    case EPackageType.AllIn:
      return EBuyPackageSource.AddFormAllIn;

    case EPackageType.SmartPackage:
      return EBuyPackageSource.AddFormSmartPack;

    default:
      return EBuyPackageSource.AddForm;
  }
};
